export default "/images/hamburger.svg?ac8c1abc17fe632fa47189df00981699";